import React from 'react';
import clsx from 'clsx';
import classes from './PaddingContainer.module.css';

const PaddingContainer = ({ className, children }) => {
  return <div className={clsx(classes.wrapper, className)}>{children}</div>;
};

export default PaddingContainer;
